'use strict';

// check if cap address is active in BM
var $iscapAddressEnable = $('#isEnableCapAddress');
var urlCapAddressCheckService = $('#url-cap-address-checkService').val();
var currentCountry = $('#currentCountry').val();

var capData = {
    countryCode: currentCountry
};
window.capency = {
    isServiceUp: true
};
var serviceInfo = false;

$.ajax({
    url: urlCapAddressCheckService,
    type: 'get',
    async: false,
    data: capData,
    dataType: 'json',
    success: function (data) {
        serviceInfo = data.CheckService;
    },
    error: function (err) { }
});

if ($iscapAddressEnable.length > 0 && $iscapAddressEnable.val() === 'true' && serviceInfo === true) {
    var formUtils = require('./formUtils');
    formUtils.initCapAddressByForms();
}
